import {
  EMPLOYEE_LIST_FETCH,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_FAILURE
} from './actionTypes';

import { ADD_EMPLOYEE_TO_THE_LIST } from '../EmployeeForm/actionTypes';

const initialState = {
  isLoaded: false,
  employees: [],
  error: []
};

export const employeesReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMPLOYEE_LIST_FETCH:
      return { ...state, isLoaded: false };
    case EMPLOYEE_LIST_SUCCESS:
      return { ...state, isLoaded: true, employees: action.payload };
    case ADD_EMPLOYEE_TO_THE_LIST:
      return {
        ...state,
        isLoaded: true,
        employees: [...state.employees, action.payload]
      };
    case EMPLOYEE_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoaded = state => state.employeeList.isLoaded;
export const getEmployees = state => state.employeeList.employees;
export const getError = state => state.employeeList.error;



// WEBPACK FOOTER //
// ./src/modules/EmployeeList/reducer.js